import { combineReducers } from 'redux';

import accountSlice from './accounts/slice';
import companySlice from './company/slice';
import userSlice from './user/slice';

export const rootReducer = combineReducers({
  accounts: accountSlice.reducer,
  user: userSlice.reducer,
  company: companySlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
